import React from 'react';
import Home from './pages/Home'
import WatchVideo from './pages/WatchVideo'
import CLECredit from './pages/CLECredit'
import CssBaseline from '@material-ui/core/CssBaseline';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

function App() {
  return (
    <React.Fragment>
      <CssBaseline />
      <Router>
        <Switch>
          <Route exact path={`${process.env.PUBLIC_URL}/`} render={(props) => <Home />}/>
          <Route path={`${process.env.PUBLIC_URL}/watch/:vid`} render={(props) => <WatchVideo {...props} />} />
          <Route path={`${process.env.PUBLIC_URL}/apply/:vid`} render={(props) => <CLECredit {...props} />} />
        </Switch>
      </Router>
    </React.Fragment>
  );
}

export default App;
